import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import {
  getUserPermissionLevel,
  getToken,
  //getUserEmail,
} from 'services/auth/tokenService';
import { decodeToken } from 'utils/auth';
import routes from 'routes';
import { clubFeaturesOf } from 'utils/clubFeatures';

// feature (optional) names an entry of clubFeaturesOf (utils/clubFeatures.js):
// the page is only for a club that has it. A school has no visitors, so its
// Visitor pages send the user to the dashboard.
const ProtectedRoute = ({ children, permissionLevel, feature }) => {
  const { selectedClub } = useSelector((state) => state.user || {});
  const token = getToken();
  //const { email } = useParams();

  if (!token) {
    toast.error('You must be logged in.');
    return <Navigate to={routes.auth.login} />;
  }

  const decodedToken = decodeToken(token);
  if (!decodedToken) {
    toast.error('You must be logged in.');
    return <Navigate to={routes.auth.login} />;
  }

  const { exp } = decodedToken;

  // const { userRole, exp } = decodedToken;

  //  if (userRole === 'AccountOwner' || userRole === 'RegisteredUser') {
  //    //console.log('Validated portal Role is :', userRole);
  //  }

  const currentTime = Math.floor(Date.now() / 1000); // Convert to seconds
  if (exp < currentTime) {
    toast.error('Session expired. Please log in again.');
    return <Navigate to={routes.auth.login} />;
  }

  const userPermissionLevel = getUserPermissionLevel();

  // Standard role-based authorization
  if (permissionLevel && userPermissionLevel < permissionLevel) {
    toast.error('You do not have permission to view the page.');
    return <Navigate to={routes.admin.dashboard} />;
  }

  // A page the selected club does not have. No message: the menu does not
  // offer it, so this is an old link or a typed address.
  if (feature && !clubFeaturesOf(selectedClub)[feature]) {
    return <Navigate to={routes.admin.dashboard} replace />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  permissionLevel: PropTypes.number,
  feature: PropTypes.string,
};

export default ProtectedRoute;
